import { useContextSelector } from 'use-context-selector';
import { PlatformContext } from '../contexts/PlatformContext';
import { useSDKContext } from '../contexts/SDKContext';

type useOnCloseScheduleProps = {
  isSpecialPage?: boolean;
  onClose?: () => void;
  onReset?: () => void;
};

export default function useOnCloseSchedule({ isSpecialPage, onClose, onReset }: useOnCloseScheduleProps) {
  const { setIsSchedulerOpen, setModalCloseOpen, clearData, fixedModule } = useContextSelector(
    PlatformContext,
    state => state
  );

  const { onClose: onCloseSDK } = useSDKContext();

  const confirmReset = () => {
    clearData();
    setModalCloseOpen?.(false);
    setIsSchedulerOpen(false);
    onClose?.();
    onReset?.();
  };

  const onCloseSchedule = () => {
    if (!fixedModule) {
      if (!isSpecialPage) setModalCloseOpen && setModalCloseOpen(true);
      if (isSpecialPage) confirmReset();
    } else onCloseSDK();
  };
  return { confirmReset, onCloseSchedule };
}
